import { createContext } from "react";

// A native application can retain the game while another workspace is visible.
// This is presentation state only; it carries no identity or learning records.
export const GameSurfaceVisibility = createContext(true);

export const GameSurfaceIntegrated = createContext(false);
